import React from 'react';
import classNames from 'classnames';
import { AssigneeDto, AssigneeType } from '@decisions/server/DecisionsFramework/ServiceLayer/Services/Assignments';
import './AssigneeAvatar.less';

interface IAssigneeAvatarProps extends React.HTMLProps<{}> {
  assignee: AssigneeDto;
}

const ASSIGNEE_AVATAR_CLASS = `dpc-avatar`;

const getInitials = (assignee: AssigneeDto) => {
  const initials = (assignee.AdditionalData ?? []).find(data => data.Name === 'Initials');
  return initials?.OutputValue ?? '';
};

const getAvatarClassForType = (assignee: AssigneeDto) => {
  switch (assignee.Type) {
    case AssigneeType.Account:
      if (getInitials(assignee)) {
        return 'dpc-avatar__icon--initials';
      }
      return 'dpc-avatar__icon--person';
    case AssigneeType.Group:
      return 'dpc-avatar__icon--group';
    case AssigneeType.Role:
      return 'dpc-avatar__icon--role';
    case AssigneeType.AssignmentFolderRights:
      return 'dpc-avatar__icon--folder-permission';
    default:
      return 'dpc-avatar__icon--person';
  }
};

const getClassNames = (className?: string) => classNames(ASSIGNEE_AVATAR_CLASS, className);
const getIconClassName = (assignee: AssigneeDto) =>
  classNames(`${ASSIGNEE_AVATAR_CLASS}__icon`, getAvatarClassForType(assignee));

/**
 * Avatar / icon for an assignee list item
 *
 * Copyright (c) 2019 Decisions ALl Rights Reserved
 */
export function AssigneeAvatar({ assignee, className }: IAssigneeAvatarProps) {
  return (
    <div className={getClassNames(className)}>
      <i className={getIconClassName(assignee)}>{getInitials(assignee)}</i>
    </div>
  );
}
